(() => {
  'use strict';
  const SH = window.SassyHive;
  if (!SH) return;

  const init = (wrapper) => {
    if (!wrapper || wrapper.dataset.storyReady === 'true') return;
    wrapper.dataset.storyReady = 'true';

    wrapper.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#sh-story-chapter-"]');
      if (!link) return;
      const target = wrapper.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: SH.prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      window.setTimeout(() => target.querySelector('h2')?.focus({ preventScroll: true }), SH.prefersReducedMotion() ? 0 : 450);
    });

    const chapters = [...wrapper.querySelectorAll('[data-sh-story-chapter]')];
    if (!('IntersectionObserver' in window)) {
      chapters.forEach((chapter) => chapter.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: .12 });
    chapters.forEach((chapter) => observer.observe(chapter));
  };

  window.addEventListener('sassy:storybook-open', (event) => init(event.detail));
  document.addEventListener('shopify:section:load', (event) => {
    const wrapper = event.target.querySelector?.('[data-sh-storybook-about]');
    if (!wrapper) return;
    wrapper.hidden = false;
    wrapper.setAttribute('aria-hidden', 'false');
    init(wrapper);
  });
  const visible = document.querySelector('[data-sh-storybook-about]:not([hidden])');
  if (visible) init(visible);
})();
